import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNameFactory } from "@src/utils/dom";
import "./panel.scss";
const cn = classNameFactory("studio-panel");
export const Panel = ({ header, children }) => {
    return (_jsxs("div", { className: cn(""), children: [_jsx("div", { className: cn("header"), children: header }), _jsx("div", { className: cn("content"), children: children })] }));
};
